"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@fluentui/react");
var react_2 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
require("./CodesNoRecordPanel.scss");
exports.CodesNoRecordPanel = function (props) {
    var _a, _b, _c;
    var url = props.url, showFrequentlyUsedLink = props.showFrequentlyUsedLink, onShowFrequentlyUsedLink = props.onShowFrequentlyUsedLink, onCodesNoRecordPanelClicked = props.onCodesNoRecordPanelClicked, showCannotFindPanel = props.showCannotFindPanel;
    var t = react_i18next_1.useTranslation('SearchComboBox').t;
    return (react_2.default.createElement("div", { className: 'codesNoRecordPanel' },
        react_2.default.createElement("span", { className: 'title' }, t('NoResult')),
        showCannotFindPanel && (react_2.default.createElement(react_2.default.Fragment, null,
            react_2.default.createElement("span", { className: 'subtitle bold' }, t('CannotFind')),
            react_2.default.createElement("p", null,
                react_2.default.createElement("span", { className: 'subtitle' }, t('CodeMaybeInactive')),
                react_2.default.createElement(react_1.ActionButton, { className: 'actionButtonLink', onClick: onCodesNoRecordPanelClicked }, (_a = t('SearchInactiveCode')) !== null && _a !== void 0 ? _a : ''),
                (url !== null && url !== void 0 ? url : '') !== '' && (react_2.default.createElement(react_2.default.Fragment, null,
                    react_2.default.createElement("span", { className: 'subtitle' }, t('OrYouMightNeedTo')),
                    react_2.default.createElement("a", { className: 'codeURL', href: url !== null && url !== void 0 ? url : '#', rel: "noopener noreferrer", target: '_blank' }, (_b = t('ToDeclareCodeUsage')) !== null && _b !== void 0 ? _b : '')))))),
        showFrequentlyUsedLink && (react_2.default.createElement(react_1.ActionButton, { className: 'actionButtonLink', onClick: function () {
                if (onShowFrequentlyUsedLink) {
                    onShowFrequentlyUsedLink();
                }
            } }, (_c = t('SeeFrequentlyUsed')) !== null && _c !== void 0 ? _c : ''))));
};
//# sourceMappingURL=CodesNoRecordPanel.js.map